import { ErrorDataState } from '@/contracts/store/ErrorDataContracts'
import { FieldsStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoResponse } from '@/contracts/api/ResponseContracts'

export const ErrorData =
{
    namespaced: true,
    state: (): ErrorDataState => (
    {
        formErrorsExist: false,
        formErrorData: {} as FieldsStructure,
        nuxeoErrorData: {} as NuxeoResponse
    }),
    getters:
    {
        formErrorsExist(state: ErrorDataState): boolean
        {
            return state.formErrorsExist
        },
        formErrorData(state: ErrorDataState): FieldsStructure
        {
            return state.formErrorData
        },
        nuxeoErrorData(state: ErrorDataState): NuxeoResponse
        {
            return state.nuxeoErrorData
        }
    },
    mutations:
    {
        setFormErrors(state: ErrorDataState, data: FieldsStructure): void
        {
            state.formErrorsExist = true
            state.formErrorData = data
        },
        resetFormErrors(state: ErrorDataState): void
        {
            state.formErrorsExist = false
            state.formErrorData = {}
        },
        setNuxeoErrors(state: ErrorDataState, data: NuxeoResponse): void
        {
            state.formErrorsExist = true
            state.nuxeoErrorData = data
        },
        resetNuxeoErrors(state: ErrorDataState): void
        {
            state.formErrorsExist = false
            state.nuxeoErrorData = {} as NuxeoResponse
        }
    }
}
